import React from "react";
import img2 from "../../../../../../assets/images/AISummit/aicopilot1.jpg";
import CustomButton from "../../../../../../shared_components/CustomButton";

import { LuCalendar } from "react-icons/lu";
import { TbTool } from "react-icons/tb";
import { GrFanOption } from "react-icons/gr";
import { IoIosArrowForward } from "react-icons/io";

const EventHostSection = () => {
    const cards = [
        {
            id: 1,
            icon: <LuCalendar size={28} />,
            title: "Co-host events",
            desc: "Bring your expertise to our platform and reach thousands of engaged developers.",
            buttontext: "Learn",
        },
        {
            id: 2,
            icon: <TbTool size={28} />,
            title: "Community partner",
            desc: "Build lasting relationships with developers and organizations who share your vision.",
            buttontext: "Connect",
        },
        {
            id: 3,
            icon: <GrFanOption size={28} />,
            title: "Sponsor growth",
            desc: "Support the community and gain visibility with developers who matter most.",
            buttontext: "Discuss",
        },
    ];

    return (
        <section className="row mx-0 align-items-center justify-content-center my-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 align-items-center py-5">
                    <div className="col-12 col-md-6">
                        <img
                            src={img2}
                            alt="Community Event"
                            className="img-fluid rounded"
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        {cards.map((item) => (
                            <div className="col-12" key={item.id}>
                                <div className="p-3 m-3 d-flex">
                                    <div className="mb-2 mr-3">{item.icon}</div>
                                    <div>
                                        <h4 className="fs-24">{item.title}</h4>
                                        <p>{item.desc}</p>
                                        <a>
                                            {item.buttontext} <IoIosArrowForward />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EventHostSection;
